import request from '@/plugin/axios'

export function ListVisits (data) {
  return request({
    url: '/visit/index',
    method: 'get',
    params: data
  })
}

export function ViewVisit (id) {
  return request({
    url: '/visit/view?id=' + id,
    method: 'get'
  })
}

export function CreateVisit (data) {
  return request({
    url: '/visit/create',
    method: 'post',
    data
  })
}

export function UpdateVisit (data) {
  return request({
    url: '/visit/update?id=' + data.id,
    method: 'post',
    data
  })
}

export function DeleteVisit (id) {
  return request({
    url: '/visit/delete?id=' + id,
    method: 'delete'
  })
}
